class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.cart = this.cart || document.querySelector('cart-drawer');

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      this.submitButton.setAttribute('aria-haspopup', 'dialog');
      if (typeof this.cart.getSectionsToRender === 'function') {
        formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
        );
      }
      formData.append('sections_url', window.location.pathname);
      if (typeof this.cart.setActiveElement === 'function') {
        this.cart.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              newVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            if (typeof response.description === "string") {
              this.handleErrorMessage(response.description);
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', newVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
      .catch((e) => {
        console.error(e);
        this.error = true;
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;

    const errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
    if (!errorMessageWrapper) return;

    const messageContainer = errorMessageWrapper.querySelector('.form__message-detail');
    if (!messageContainer) return;

    errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      messageContainer.textContent = errorMessage;
    }
  }
}

customElements.define('product-form', ProductForm);
